import React from "react";
import "./index";

const New = (props) => {
  const { title, desc } = props;
  return (
    <div className="new">
      <div className="title">{title}</div>
      <div className="desc">{desc}</div>
    </div>
  );
};

export default New;
